// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const recoverySections: PaneSection[] = [
  {
    section: 'intro',
    title: 'Account recovery',
    body: 'Your recovery phrase lets you restore your account if you ever lose your devices. Keep it somewhere safe, because it is the only way back in and support cannot reset it for you.',
  },
  {
    section: 'backup-status',
    title: 'Backup status',
    body: 'This tells you whether your account is backed up and when it last happened. If it warns you that no backup exists, set one up to protect your account.',
  },
  {
    section: 'phrase',
    title: 'Your recovery phrase',
    body: 'Reveal your phrase here so you can write it down and store it somewhere safe. Anyone who has it can restore your account, so keep it private.',
  },
  {
    section: 'rotate',
    title: 'Rotate your recovery key',
    body: 'Generate a fresh phrase and replace the old one if you think your current phrase may have been seen by someone else. Your previous phrase stops working right away.',
  },
  {
    section: 'how-it-works',
    title: 'How recovery works',
    body: 'Your account is locked on this device before anything is saved, so only a scrambled copy ever leaves it. Your phrase never reaches Ping and cannot be reset by support.',
  },
];
